export const FINANCED_STATUS_NAME = {
  FINANCED: "Financiamiento",
  CASH: "Efectivo",
};

export const status_sells_category_select = [
  {
    text: "Reserva",
    value: "A",
  },
  {
    text: "Venta declarada",
    value: "B",
  },
  {
    text: "Reserva cancelada",
    value: "C",
  },
  {
    text: "Venta facturada",
    value: "D",
  },
  {
    text: "Venta cancelada",
    value: "F",
  },
];

export const providerOptions = [
  { value: "Santander Río", text: "Santander Río" },
  { value: "Supervielle", text: "Supervielle" },
  { value: "Iudú", text: "Iudú" },
  { value: "Mila", text: "Mila" },
  { value: "DeCréditos", text: "DeCréditos" },
  { value: "Uala", text: "Uala" },
  { value: "Galicia", text: "Galicia" },
];

export const financed_status = {
  PENDING_FINANCED: {
    color: "badgePresentationWaiting",
    text: "P - Prenda Pendiente",
    value: 1,
    next: ["RETIRED"],
  },
  RETIRED: {
    color: "badgePresentationReceptionCat",
    text: "P - Retirada",
    value: 10,
    next: ["BANK_SENT", "SCAN_BANK_ANALYSIS"],
  },
  SCAN_BANK_ANALYSIS: {
    color: "badgePresentationDelivered",
    text: "P - Escaneada para Analísis del Banco",
    value: 11,
    next: ["BANK_SENT", "BANK_OBSERVED"],
  },
  BANK_SENT: {
    color: "badgePresentationReceptionCat",
    text: "P - Enviada al Banco",
    value: 6,
    next: ["BANK_OBSERVED"],
  },
  BANK_OBSERVED: {
    color: "badgePresentationObserved",
    text: "P - Observado por Banco",
    value: 4,
    next: ["BANK_RESENT"],
  },
  BANK_RESENT: {
    color: "badgePresentationPresented",
    text: "P - Reenviada al Banco",
    value: 12,
    next: ["COMPLETED"],
  },
  REGISTRATION_COPY_REQUEST: {
    color: "badgeRejected",
    text: "P - Solicitud Copia Registral",
    value: 7,
    next: null, // vuelve al estado anterior
  },
  COMPLETED: {
    color: "badgeCompleted",
    text: "P - Completado",
    value: 8,
  },
  REJECTED: {
    color: "badgeRejected",
    text: "P - Rechazado",
    value: 9,
  },
};
